import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, CardContent } from '@guildeducationinc/recess';
import { AdminTopNav } from '@src/components/Admin/AdminTopNav';
import { ReportConfig } from '@src/components/Admin/ReportConfig';
import { ReportViewer } from '@src/components/Admin/ReportViewer';
import { useClientIdParam } from '@src/hooks/useClientIdParam';
import { useReports } from '@src/hooks/useReports';
import { emptyReportTemplate } from '@src/types';
import { useLocale } from 'pe-core-frontend';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
export const Report = () => {
    const { t } = useLocale();
    const clientId = useClientIdParam() || 1;
    const { id } = useParams();
    const { find } = useReports({
        clientId,
        id: Number(id),
    });
    const found = find(Number(id));
    const [reportTemplate, setReportTemplate] = useState(emptyReportTemplate);
    useEffect(() => {
        setReportTemplate(found ?? emptyReportTemplate);
    }, [found]);
    return (_jsxs("div", { children: [_jsx(AdminTopNav, { title: reportTemplate?.name || t('Report Data') }), _jsx("div", { children: _jsx(Card, { children: _jsx(CardContent, { children: _jsxs("div", { className: 'flex', children: [_jsx("div", { className: 'basis-64 p-3 border-solid border-r border-gray-500', children: _jsx(ReportConfig, { reportTemplate: reportTemplate, onChange: reportTemplate => setReportTemplate(reportTemplate) }) }), _jsx("div", { className: 'grow p-3', children: reportTemplate && _jsx(ReportViewer, { reportTemplate: reportTemplate }) })] }) }) }) })] }));
};
